import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { SettingsEntity } from '../../common';
import { environment } from '../../environments';
import { ApiBaseService } from './api-base.service';
import { Hub } from '../abstract/hub.abstract';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiCourseSettingsService extends ApiBaseService implements OnDestroy {
  protected apiBaseUrl = environment.campusV2;
  protected routePath = `hubs/${this._hubService.hub()}/courses`;

  public subscription: Subscription;

  constructor(private _hubService: Hub, private _httpClient: HttpClient) {
    super(_httpClient);

    this.subscription = this._hubService.onHubChange.subscribe(() => {
      this.routePath = `hubs/${this._hubService.hub()}/courses`;
    });
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public getCourseSettings(courseSlug: string): Promise<SettingsEntity[]> {
    const path = `${courseSlug}/settings`;
    return super.get<SettingsEntity[]>(path);
  }
}
